
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { SignatureCollectionsSection } from './components/SignatureCollectionsSection';

const StaysPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <SignatureCollectionsSection />
      </main>
      <Footer />
    </div>
  );
};

export default StaysPage;